export const ENV: string =
  import.meta.env.VITE_NODE_ENV === 'development'
    ? 'DEV'
    : import.meta.env.VITE_NODE_ENV === 'production'
    ? 'PROD'
    : 'LOCAL'
